import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import { EmailOtpFlow } from '../components/EmailOtpFlow';

/**
 * Sign-in / sign-up screen. Renders the in-app email-OTP flow (enter email →
 * receive a code → verify), matching the mobile experience. Federated social
 * sign-in (Google/Microsoft/Apple) still hands off to Zitadel from inside the
 * flow. Already-authenticated visitors are bounced to their destination.
 */
export function SignUpPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { authUser } = useAuth();
  const from = (location.state as { from?: string } | null)?.from;

  useEffect(() => {
    if (authUser) navigate(from || '/app', { replace: true });
  }, [authUser, from, navigate]);

  return <EmailOtpFlow />;
}

export default SignUpPage;
